//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
    Fragment,
    useState,
    useEffect,
    useContext,
    useCallback,
} from 'react';
import { useTranslation } from 'react-i18next';

// custom pages
import Table from 'components/Table/Table';
import MilestoneTrackingAPI from 'apis/MilestoneTracking/MilestoneTracking';
import Context from 'context/context';
import searchIcon from 'assets/img/Search_Icon.png';
import { styles } from './styles';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { toast } from "react-toastify";
import MilestoneCriteria from "views/Dashboard/MilestoneCriteria/MilestoneCriteria";

// material-ui
import TextField from '@material-ui/core/TextField';
import {
    withStyles,
    Grid,
    InputAdornment,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Switch
} from '@material-ui/core';


// material-ui icons
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import {
  Box,
  Tabs,
  Tab,
} from "@material-ui/core";
// Helpers
import useDebounce from 'helpers/useDebounce';
import { blockInvalidChar } from 'helpers/blockInvalidChar';
import * as moment from "moment";
import { CSVLink } from 'react-csv';
import { exportHeaders } from "./export";
import { useHistory, useLocation } from 'react-router-dom';

// custom TextField
const CssTextField = withStyles({
    root: {
        '& label.Mui-focused': {
            color: '##D3D3D3',
        },
        '& .MuiFormLabel-root': {
            color: '#707070',
        },
        '& .MuiInputBase-input': {
            color: '#707070',
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: '#707070!important',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#707070!important',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#707070',
            },
            '&:hover fieldset': {
                borderColor: '#707070',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#707070',
            },
            '&.MuiOutlinedInput-root': {
                borderRadius: 20,
            },
            '&.MuiOutlinedInput-root': {
                marginTop: 0,
                borderRadius: 20,
                background: '#ededed',
            },
        },
    },
})(TextField);

export default function MilestoneTracking() {

    const {
        getAPI,
        searchAPI,
        Export,
        updateAutoRedemptionFlagAPI
    } = MilestoneTrackingAPI();

    const { state, dispatch } = useContext(Context);

    const classes = styles();
    const history = useHistory();
    const location = useLocation();

    const [data, setData] = useState([]);
    const [offset, setOffset] = useState(1);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [exportLoading, setExportLoading] = useState(false);
    
    // Tabs
    const [tabValue, setTabValue] = useState(0);
    const [searchValue, setSearchValue] = useState('');
    const [exportData, setExportData] = useState([]);

    const { t } = useTranslation();

    const [response, setResponse] = useState({ filter: false });

    const searchBounceValues = useDebounce(searchValue);

    const [toggleDialog, setToggleDialog] = useState({
        open: false,
        row: null,
        value: false
    });
    const params = new URLSearchParams(location.search);

    const childTab = parseInt(params.get('childTab') || '0');
    // Common State Object
    const [states, setstates] = useState({
        clearSearch: false,
    });

    const setStates = useCallback((newState) => {
        setstates((states) => ({ ...states, ...newState }));
    }, []);

    const { clearSearch } = states;

    // Page Path Name
    useEffect(() => {
        dispatch({
            type: 'SET_PATHNAME',
            payload: ['HOME', 'ADMIN', 'Growth Bonus Tracker'],
        });
    }, []);

    // Handling Get and Search API
    useEffect(() => {
        if (tabValue !== 0) return;

        if (clearSearch) return;

        if (searchBounceValues?.length > 0) {
            handleSearch();
        } else {
            getDetails();
        }

    }, [searchBounceValues, offset]);

const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleChildTabChange = (event, newValue) => {
    params.set('childTab', newValue);
    history.replace({ search: params.toString() });
  };
    // Pagination
    const handlePagination = (value) => {
        setOffset(value);
        getDetails();
    };

    // Get API
    async function getDetails() {

        try {

            let values = {
                offset: (offset - 1) * 10,
                limit: 10,
            };

            dispatch({ type: "SET_LOADING", payload: true });

            let res = await getAPI(values);

            if (res) {

                setData(res.data || []);
                setCount(res.count || 0);
                setLoading(false);

                dispatch({
                    type: 'SET_LOADING',
                    payload: false
                });
            }

        } catch (e) {
            console.log("Error fetching data: ", e);
        }
    }

    // Search API
    async function handleSearch() {

        try {

            setLoading(true);

            let values = {
                search: searchValue,
                offset: (offset - 1) * 10,
                limit: 10,
            };

            setResponse({ ...response, filter: false });

            dispatch({ type: "SET_LOADING", payload: true });

            let res = await searchAPI(values);

            if (res) {

                setData(res.data || []);
                setCount(res.count || 0);
                setLoading(false);

                dispatch({
                    type: 'SET_LOADING',
                    payload: false
                });
            }

        } catch (e) {
            console.log({ e });
        }
    }

    // Table Headings
    let tableHeading = [
        'Loyalty ID',
        'Billto',
        'Shipto',
        'Unlock Start Date',
        'Unlock End Date',
        //'Milestone Progress',
        // 'Auto Redemption Flag',
        'View'
    ];

    // Export
    const handleExport = async () => {

        try {

            let values = { searchValue };

            setExportLoading(true);

            dispatch({
                type: "SET_LOADING",
                payload: true
            });

            let res = await Export(values);

            if (res && res.data) {

                setExportData(res.data);

                dispatch({
                    type: "SET_LOADING",
                    payload: false
                });

                setExportLoading(false);

                if (res.data.length === 0) {

                    toast.success(
                        t("No Data Found"),
                        { toastId: "no-report-date" }
                    );

                    return false;
                }

                return true;
            }

        } catch (e) {

            console.log({ e });
            setExportLoading(false);
        }
    };

    // Toggle Auto Redemption
    // const handleToggleAutoRedemption = async () => {
    //     try {

    //         const values = {
    //             shipto: toggleDialog.row.customer_account_number,
    //             auto_redemption_flag: toggleDialog.value // ✅ BOOLEAN ONLY
    //         };

    //         console.log("PAYLOAD SENT:", values);

    //         const res = await updateAutoRedemptionFlagAPI(values);

    //         if (res) {
    //             toast.success("Auto Redemption Updated successfully");

    //             setToggleDialog({
    //                 open: false,
    //                 row: null,
    //                 value: false
    //             });

    //             getDetails();
    //         }

    //     } catch (e) {
    //         console.log(e);
    //         toast.error("Failed to update Auto Redemption");
    //     }
    // };

    return (
        <Fragment>
             {/* ================= TABS ================= */}
      {/* <Box
        style={{
          marginBottom: "20px",
          background: "#fff",
          borderRadius: "12px",
          padding: "5px 10px",
        }}
      >
        <Tabs
          value={childTab} onChange={handleChildTabChange}
          TabIndicatorProps={{
            style: { backgroundColor: "#007bff"},
          }}
        >
          <Tab label="Milestone Management" />
          <Tab label="Customer Bonus Tracking" />
        </Tabs>
      </Box> */}

      {/* ================= TAB CONTENT ================= */}
      {/* {childTab === 0 ? (
        <MilestoneCriteria />
      ) : (
        <> */}


            <Grid item xs={12} sm={12} lg={12} className={classes.topGrid}>

                <div style={{ flex: 1 }}>

                    <CssTextField
                        id="search"
                        placeholder="Search for Shipto ID"
                        onKeyDown={blockInvalidChar}
                        type="number"
  onWheel={(e) => e.target.blur()}
                        variant="outlined"
                        autoComplete="off"
                        className={classes.searchInput}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">

                                    {searchValue.length > 0 ? (

                                        <CloseOutlinedIcon
                                            className={classes.searchInputIcon}
                                            onClick={() => {

                                                setStates({
                                                    clearSearch: true
                                                });

                                                setSearchValue("");

                                                if (offset === 1) {
                                                    getDetails();
                                                } else {
                                                    setOffset(1);
                                                }
                                            }}
                                        />

                                    ) : (

                                        <img
                                            src={searchIcon}
                                            alt=""
                                            width="20px"
                                            className={classes.searchInputIcon}
                                        />

                                    )}

                                </InputAdornment>
                            ),
                        }}
                        value={searchValue}
                        onChange={(e) => {

                            const val = e.target.value.replace(/\s+/g, "");

                            setSearchValue(
                                val.length === 0 ? "" : e.target.value
                            );

                            setOffset(1);

                            if (e.target.value.length === 0) {
                                getDetails();
                            }
                        }}
                    />

                </div>

                {/* RIGHT SIDE BUTTONS */}
                <Grid
                    item
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                    }}
                >


                    {/* CSV */}
                    <CSVLink
                        id="csv"
                        data={exportData.map(item => ({
                            ...item,
                            is_active: item.is_active ? "Active" : "Inactive",
                        }))}
                        headers={exportHeaders}
                        filename={
                            `Unlock_Shipto_Accounts ` +
                            moment(new Date()).format("MM-DD-YYYY,h:mm A") +
                            ".csv"
                        }
                        className={classes.CSVlink}
                    />

                    {/* EXPORT */}
                    {/* <button
                        disabled={exportLoading}
                        className={classes.exportBtn1}
                        onClick={async () => {

                            const res = await handleExport();

                            if (res) {
                                document.getElementById("csv").click();
                            }
                        }}
                    >

                        {exportLoading ? (

                            <div className="snippet">
                                <div className="stage">
                                    <div className="dot-typing-e"></div>
                                </div>
                            </div>

                        ) : (
                            t("Export")
                        )}

                    </button> */}

                </Grid>

            </Grid>

            {/* TABLE */}

            <div style={{ marginTop: 20 }}>

                {!loading ? (

                    <Table
                        headings={
                            tableHeading.map((i) => (
                                <div
                                    style={{
                                        textAlign: "center",
                                        width: "100%"
                                    }}
                                    key={t(i)}
                                >
                                    {t(i)}
                                </div>
                            ))
                        }
                        data={
                            data?.map((d, i) => [
                                 // Loyalty ID
                                <div style={{ textAlign: "center" }}>
                                    {d?.loyalty_id}
                                </div>,
                                
                                // Billto
                                <div style={{ textAlign: "center" }}>
                                    {d?.customer_billto_account_number}
                                </div>,

                                // Shipto
                                <div style={{ textAlign: "center" }}>
                                    {d?.customer_account_number}
                                </div>,

                               

                                // Unlock Start Date
                                <div style={{ textAlign: "center" }}>
                                    {
                                        d?.unlock_start_date
                                            ? moment(d.unlock_start_date).format("MM/DD/YYYY")
                                            : "-"
                                    }
                                </div>,

                                // Unlock End Date
                                <div style={{ textAlign: "center" }}>
                                    {
                                        d?.unlock_end_date
                                            ? moment(d.unlock_end_date).format("MM/DD/YYYY")
                                            : "-"
                                    }
                                </div>,

                                // // Status
                                // <div style={{ textAlign: "center" }}>
                                //     <span
                                //         style={{
                                //             padding: "6px 14px",
                                //             borderRadius: "20px",
                                //             fontSize: "12px",
                                //             fontWeight: 700,
                                //             color: "#fff",
                                //             background:
                                //                 d?.status === "ACTIVE"
                                //                     ? "#008000"
                                //                     : d?.status === "COMPLETED"
                                //                         ? "#8c8c8c"
                                //                         : "#ff0000",
                                //             display: "inline-block",
                                //             minWidth: "90px",
                                //             textAlign: "center",
                                //             letterSpacing: "0.3px",
                                //         }}
                                //     >
                                //         {d?.status === "ACTIVE"
                                //             ? "Active"
                                //             : d?.status === "COMPLETED"
                                //                 ? "Completed"
                                //                 : "Inactive"}
                                //     </span>
                                // </div>,
                                // // Auto Redemption Toggle
                                // <div
                                //     style={{
                                //         display: "flex",
                                //         justifyContent: "center",
                                //         alignItems: "center"
                                //     }}
                                // >
                                //     {d?.status === "ACTIVE" ? (
                                //         <Switch
                                //             checked={d?.auto_redemption_flag == 1}
                                //             color="primary"
                                //             onChange={(e) => {
                                //                 setToggleDialog({
                                //                     open: true,
                                //                     row: d,
                                //                     value: e.target.checked
                                //                 });
                                //             }}
                                //         />
                                //     ) : (
                                //         <span>-</span>
                                //     )}
                                // </div>,
                                // View
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => {
                                        history.push(
                                            '/dashboard/unlock-milestone-view',
                                            { data: d }
                                        );
                                    }}
                                >
                                    <VisibilityIcon />
                                </div>
                            ])
                        }
                        offset={offset}
                        count={Math.ceil(count / 10)}
                        handlePagination={handlePagination}
                    />

                ) : (

                    <div
                        style={{
                            height: '25vh',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <h2>{t('Loading...')}</h2>
                    </div>

                )}

            </div>

            {/* TOGGLE DIALOG */}

            {/* <Dialog
                open={toggleDialog.open}
                onClose={() =>
                    setToggleDialog({
                        open: false,
                        row: null,
                        value: false
                    })
                }
            >

                <DialogTitle>
                    Auto Redemption Confirmation
                </DialogTitle>

                <DialogContent>

                    <DialogContentText>

                        {toggleDialog?.value
                            ? "Are you sure you want to allow auto redemption for this shipto?"
                            : "Are you sure you want to disable auto redemption for this shipto?"
                        }

                    </DialogContentText>

                </DialogContent>

                <DialogActions>

                    <Button
                        onClick={() =>
                            setToggleDialog({
                                open: false,
                                row: null,
                                value: false
                            })
                        }
                        color="secondary"
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={handleToggleAutoRedemption}
                        color="primary"
                        variant="contained"
                    >
                        Confirm
                    </Button>

                </DialogActions>

            </Dialog> */}
            {/* </>
        )} */}
        </Fragment>
    );
}